import axios from "axios";
import callApi from "./callApi";

const getComments = async (entityType, entityId, projectId) => {
  const url = `comments/${entityType}/${entityId}?projectId=${projectId}`;

  return await callApi(url, {}, "GET");
};

const addComment = async (comment, projectId) => {
  const url = `comments?projectId=${projectId}`;
  return await callApi(url, {}, "POST", comment);
}

const updateComment = async (id, comment) => {
  const url = `comments/${id}`;
  return await callApi(url, {}, "PUT", comment);
}

const deleteComment = async (commentId) => {
  const url = `comments/${commentId}`;
  return await callApi(url, {}, "DELETE");
}

const getAttachments = async (entityType, entityId) => {
  const url = `attachments/${entityType}/${entityId}`;
  return await callApi(url, {}, "GET");
}

const deleteAttachment = async (attachmentId) => {
  const url = `attachments/${attachmentId}`;
  return await callApi(url, {}, "DELETE");
}

const updateAttachment = async (attachmentId, attachment) => {
  const url = `attachments/${attachmentId}`;
  return await callApi(url, {}, "PUT", attachment);
}

const getTestCaseHistory = async (testCaseId) => {
  const url = `testcases/history/${testCaseId}`;
  return await callApi(url, {}, "GET");
}

const archiveTestCase = async (data) => {
  const url = `testcases/archive`;
  return await callApi(url, {}, "PUT", data);
}

const bulkCreateTestCase = async (data, projectId) => {
  const url = `testcases/bulk-create?projectId=${projectId}`;
  return await callApi(url, {}, "POST", data);
}

const importTestCase = async (data, projectId) => {
  const url = `testcases/import-testcase?projectId=${projectId}`;
  return await callApi(url, {}, "POST", data);
}

const deleteTestCase = async (data) => {
  const url = `testcases/delete`;
  return await callApi(url, {}, "POST", data);
}

const exportTestCases = async (data, projectId) => {
  const url = `testcases/export/${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };

  return await callApi(url, headers, "POST", data, "blob");
};

export {
  getAttachments,
  deleteAttachment,
  updateAttachment,
  getComments,
  addComment,
  updateComment,
  deleteComment,
  getTestCaseHistory,
  archiveTestCase,
  bulkCreateTestCase,
  deleteTestCase,
  exportTestCases,
  importTestCase
}